import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ApiCall } from './ApiCall';
import store from './store';

class AppInsightsService {
  private static instance: AppInsightsService;
  private appInsights: ApplicationInsights;

  private constructor() {
    if (store.analytics === false) return;
    try {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString:
            'InstrumentationKey=2b60d1de-2e6d-46a0-b0ab-ac29e20e0a9c;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f5742904-b013-46ab-954b-46ba6f300b95',
          enableAutoRouteTracking: true, // Optional: Tracks route changes
        },
      });

      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    } catch (error) {
      ApiCall.instance.AddLog('AppInsightsService', error);
    }
  }

  public static getInstance(): AppInsightsService {
    if (!AppInsightsService.instance) {
      AppInsightsService.instance = new AppInsightsService();
    }
    return AppInsightsService.instance;
  }

  public trackEvent(name: string, properties?: { [key: string]: any }) {
    if (store.analytics === false) return;
    try {
      this.appInsights.trackEvent({ name }, properties);
    } catch (error) {
      ApiCall.instance.AddLog('AppInsightsService | trackEvent', error);
    }
  }

  public trackException(properties: { [key: string]: any }, error: Error) {
    if (store.analytics === false) return;
    try {
      this.appInsights.trackException({ exception: error, properties });
    } catch (error) {
      ApiCall.instance.AddLog('AppInsightsService | trackException', error);
    }
  }

  public trackPageView(name?: string) {
    if (store.analytics === false) return;
    try {
      this.appInsights.trackPageView({ name });
    } catch (error) {
      ApiCall.instance.AddLog('AppInsightsService | trackPageView', error);
    }
  }
}

export default AppInsightsService;
